<template>
  <LightingAdvisorTool v-if="mode === 'wizard'" :item="item" />
  <LightingAdvisorTiles v-else />
</template>

<script setup lang="ts">
import type { ITechnicalComponent } from '~~/lib/ContentfulService';
import LightingAdvisorTool from '~/components/global/lib/LightingAdvisorTool.vue';
import LightingAdvisorTiles from '~/components/global/lib/LightingAdvisor/LightingAdvisorTiles.vue';
import { parseLightingAdvisorMode } from '~/utils/lightingAdvisor/configurationSchema';

interface Props {
  item: ITechnicalComponent;
}

const props = defineProps<Props>();

const mode = computed(() =>
  parseLightingAdvisorMode(props.item.fields.configuration)
);
</script>
